import { render } from "./mnewDetails.vue?vue&type=template&id=70411aa2&scoped=true"
import script from "./mnewDetails.vue?vue&type=script&lang=js"
export * from "./mnewDetails.vue?vue&type=script&lang=js"

import "./mnewDetails.vue?vue&type=style&index=0&id=70411aa2&scoped=true&lang=css"

import exportComponent from "D:\\code\\vifa官网\\vifa\\vifa-website\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70411aa2"]])

export default __exports__